<template>
  <div>
    <!-- 附件上傳 -->
    <validation-observer ref="observer">
      <!-- <base-box :title="titleM"   v-if="'M' === polInsureType" >
        <sub-header  >
          <template v-slot:title>
            <div>
              <span class="required">行動投保同意書</span>
              <span style="color: red;"> 凱壽APP限JPG格式檔案，若非請先轉存JPG格式</span>
            </div>
          </template>
        </sub-header>
          <validation-observer v-slot="{errors}"  >
          <upload-input ref="filesA"
                        v-model="filesA"
                        :filesUpd="filesA"
                        :file-type="'A'"
                        :is-preview="isPreview"
                        :error-messages-hidden="true"
                        @file-picker="filePickerLog"
                        @upload="onUpload"
                        @delete="onDelete"
                        @chg-has-tmp="onChangeHasTmp" >
          </upload-input>
          <error-messages style="margin-top: 0px;" :value="errorsHandler(errors)"></error-messages>
          <validation-provider name="行動投保同意書"
                               vid="filesA"
                               :rules="isPreview ? '' : 'uploadRequired'"
                               :immediate="filesA.length>0">
            <input :value="filesA[0]" style="height:0;width:0;" id="filesA"/>
          </validation-provider>
        </validation-observer>
      </base-box> -->
      <base-box>
        <sub-header>
          <template v-slot:title>檔案下載</template>
        </sub-header>
          行動投保同意書下載：
          <!-- <v-btn color="amber" style="border-radius: 50%;position: fixed;bottom: 20px;right: 30px;min-width: 70px;height: 70px" @click="consentDownloadHandler()" >
                  下載
                </v-btn> -->
          <v-btn outline
              fab
              small
              v-ripple="false"
              @click="consentDownloadHandler()">下載</v-btn>
          <strong>（若還沒下載請點此處下載列印）</strong>
      </base-box>
      <base-box :title="titleRole" v-if="loginRole">
      <sub-header>
        <template v-slot:title>內部件申請書</template>
      </sub-header>
      <validation-observer v-slot="{errors}">
        <upload-input ref="filesB"
                      v-model="filesB"
                      :file-type="'B'"
                      :filesUpd="filesB"
                      :is-preview="isPreview"
                      @file-picker="filePickerLog"
                      @upload="onUpload"
                      @delete="onDelete"
                      @chg-has-tmp="onChangeHasTmp" >
        </upload-input>
        <error-messages v-if="loginRole" style="margin-top: 0px;" :value="errorsHandler(errors)"></error-messages>
        <validation-provider name="內部件申請書"
                             vid="filesB"
                             :rules="(isPreview || !loginRole )  ? '' : 'uploadRequired'"
                             :immediate="filesB.length > 0">
            <input v-if="filesB" :value="filesB[0]" style="height:0;width:0;" id="filesB" />
          </validation-provider>
        </validation-observer>
      </base-box>
      <base-box  :title="titleR">
        <sub-header >
          <template v-slot:title>其他</template>
        </sub-header>
        <upload-input ref="filesC"
                      v-model="filesC"
                      :file-type="'C'"
                      :filesUpd="filesC"
                      :is-preview="isPreview"
                      @file-picker="filePickerLog"
                      @upload="onUpload"
                      @delete="onDelete"
                      @chg-has-tmp="onChangeHasTmp" >
        </upload-input>
      </base-box>
    </validation-observer>

    <base-note no-num
               :note-items="noteList">
    </base-note>
    <base-btn>
    <btn-lg-default class="float-left"
                    :disabled="isPreview"
                    @click="resetHandler">全部清除</btn-lg-default>
      <btn-lg-default @click="preStepHandler">上一步</btn-lg-default>
      <btn-lg-primary @click="nextStepHandler">下一步</btn-lg-primary>
      <!--
      <btn-lg-primary @click="nextStepHandler" v-if="'M' === polInsureType ">下一步</btn-lg-primary>
      <btn-lg-primary @click="nextStepHandler" v-else>連到APP</btn-lg-primary>
       -->
      <btn-lg-default style="position: fixed;top: 300px;right: 30px;min-width: 126px; max-width: 126px;" @click="preStepHandler" v-if="'M' === polInsureType " >上一步</btn-lg-default>
      <btn-lg-primary style="position: fixed;top: 360px;right: 30px;min-width: 126px; max-width: 126px;" @click="nextStepHandler" v-if="'M' === polInsureType ">下一步</btn-lg-primary>

    </base-btn>
  </div>
</template>

<script>
import UploadInput from '@/components/Ins/Policy/UploadInput.vue'
import store from '@/store'
import { withDebounce } from '@/utils'
import { filter } from 'lodash'
import { createNamespacedHelpers } from 'vuex'
import ProposalStepsBase from './/ProposalStepsBase'
const { mapActions } = createNamespacedHelpers('ins')
export default {

  extends: ProposalStepsBase,

  components: { UploadInput },

  data () {
    return {
      filesA: [], // 行動投保同意書
      filesB: [], // 內部件申請書
      filesC: [], // 其他
      hasTmpFileA: false,
      hasTmpFileB: false,
      hasTmpFileC: false,
      stepCode: 'M' === this.polInsureType ? 'INS_S5' : 'REMOTE_S5',
      allHasTmpFile: false, //檢查是否有檔案未上傳(開發時已改為true)
      insFileList: [], // 已有拍照上傳資料
      noteList: [
        '本關卡可以直接按下一步（拍照或上傳為非必要流程)<br>提醒：需下載同意書並列印攜出，面訪時請客戶簽署於保險公司流程末端再拍照上傳。',
        '上傳的檔案格式限制為 PDF, JPG, PNG 檔',
        '檔案大小需為5Mb以下'
      ],
      cusInfoTypeO: {}, //遠距增加，跳轉APP
      policiesInfo: {}, //遠距增加，跳轉APP
    }
  },

  computed: {
    insFileLimit () {
      // 可上傳檔案數量(ADM_PARMD-S01)
      let { parameterValue: limit } = this.insParameters['FILE_LIMIT']
      limit = parseInt(limit)
      return limit
    },
    insOtherFileLimit () {
      // 其他附件檔案上傳限制數量(ADM_PARMD-S01)
      let { parameterValue: limit } = this.insParameters['OTHER_FILE_LIMIT']
      limit = parseInt(limit)
      return limit
    },
    loginRole () { // 『登入角色』= 'BM1' 顯示此區塊且必填
      let userInfo =  this.$store.getters["user/info"]
      return 'BM1' === userInfo.roleCode
    },
    insAppTime () {  //遠距增加，跳轉APP
      // APP提醒時間(ADM_PARMD-S01)
      let { parameterValue: limit, variableDesc: desc } = this.insParameters['APP_REMIND_TIME']
      limit = parseInt(limit)
      return {limit, desc}
    },
    insHighAgeLimit () {  //遠距增加， 高齡年齡限制(ADM_PARMD-S01)
      let { parameterValue: limit } = this.insParameters['HIGH_AGE_LIMIT']
      limit = parseInt(limit)
      return limit
    },
    titleM () { // 行投才要固定顯示標題
      return 'M' === this.polInsureType ? '證明文件項目' : null
    },
    titleRole () { // 遠距 且 『登入角色』= 'BM1'   才要顯示標題
      return 'R' === this.polInsureType ? '證明文件項目' : null
    },
    titleR () { // 遠距 且 『登入角色』!= 'BM1' 才要顯示標題
      return 'R' === this.polInsureType && !this.loginRole  ? '證明文件項目' : null
    }
  },

  beforeRouteEnter (to, from, next) {
    const { transCode, } = to.params.propKey
    const reqCusInfo = store.dispatch('ins/fetchCusInfo', { transCode, cusType: ['O'] }) //遠距增加，跳轉APP
    const reqPolf = store.dispatch('ins/fetchInsPoliciesPolf', { transCode, fileGroup: ['ATTACH'] }) // 檔案列表
    const reqPoliciesInfo = store.dispatch('ins/fetchInsPoliciesInfo', { transCode }) //保單資訊
    Promise.all([reqCusInfo, reqPolf, reqPoliciesInfo]).then(r => {
      const [rCusInfo, rPolf,  rPoliciesInfo] = r
      next(vm =>{
        vm.insFileList = rPolf.data
        vm.cusInfoTypeO = rCusInfo.data.cusList[0]  //遠距增加，跳轉APP
        vm.policiesInfo = rPoliciesInfo.data  // 遠距增加，跳轉APP
        if (!vm.isPreview) {
          vm.doValidate()
        }
      })
    })
  },
  watch: {
    insFileList: { // 已上傳檔案列表，全撈之後再分類
      handler (v) {
        if (v) {
          this.filesA = []
          this.filesB = []
          this.filesC = []
          for (let idx in v) {
            let polf = v[idx]
            polf.name = polf['fileName']
            switch (polf['fileType']) {
              case 'A':
                this.filesA.push(polf)
                break
              case 'B':
                this.filesB.push(polf)
                break
              case 'C':
                this.filesC.push(polf)
                break
            }
          }
        }
      },
      immediate: true,
      deep: true
    },
    changedFlag (v) {
      if (v) {
        this.$setTabDone(this.tabStep, false )
      }
    },
  },
  methods: {
    ...mapActions([
      'fetchInsPoliciesPolf',
      'postUpdFileBase64',
      'delFile',
      'delAllFile',
      'fetchAttachmentUpload',
      'fetchJumpApp'
    ]),
    startLoading () {
      this.$store.commit('START')
    },
    endLoading () {
      this.$store.commit('END')
    },
   nextStepHandler: withDebounce(function () {  //下一步
      if (this.isPreview) { // 檢視
        this.$postUserAccessLog({ progClassName: 'attachmentUpload_next', methodName: '下一步', stepCode: this.tabStep })
        this.$nextStepHandler()
      } else {
        if (this.allHasTmpFile) {
            this.$alert('仍有檔案未上傳!')
          } else {
            this.$changedReset()
            this.fetchAttachmentUpload({transCode: this.transCode}).then( r => {
             this.doValidate(true)
             this.$nextStepHandler()
             this.$postUserAccessLog({ progClassName: 'attachmentUpload_next', methodName: '下一步', stepCode: this.tabStep })
            })
          }
        }
    }),
    nextStepHandler2: withDebounce(function () {  //下一步
      if (this.isPreview) { // 檢視
        this.$postUserAccessLog({ progClassName: 'attachmentUpload_next', methodName: '下一步', stepCode: this.tabStep })
        this.$nextStepHandler()
      } else {
        if (this.allHasTmpFile) {
            this.$alert('仍有檔案未上傳!')
          } else {
            this.$changedReset()
            const transCode = this.transCode
            this.fetchAttachmentUpload({transCode}).then( r => {
              if ('M' === this.polInsureType) {  //行動投保
                this.doValidate(true)
                this.$nextStepHandler()
                this.$postUserAccessLog({ progClassName: 'attachmentUpload_next', methodName: '下一步', stepCode: this.tabStep })
              } else {  //遠距流程
                this.$doValidate('observer').then(isValid => {
                  if (isValid) {

                    // 檢核前面頁籤必填項目是否皆已填寫
                    let errMsg = ''
                    this.tabList.forEach(item => {
                      if (item.show && item.validateNum > 0) {
                        errMsg += item.name + '/'
                      }
                    })
                    if (errMsg.length > 0) {
                      this.$alert('請檢視' + errMsg.slice(0, -1) + '頁籤，是否仍有必要未填入欄位！')
                      return
                    }
                    let msg = []
                    msg.push('進入保險公司則不可再異動基本資料，若需異動可退回網頁重新複製調整後再進件，行動投保同意書需以新案號列印給客戶簽署，採遠距投保時，請複製案件重新調整後再進入保險公司')
                    msg.push('若繳款人非要/被保險人且為高齡者(65歲以上)，請先完成保險公司高齡錄音取得錄音編號')
                    msg.push('若保戶欲投保之商品同時有躉繳及分期繳，採分期繳者請於保險公司商品選擇時留意挑有數字的如 APKSPL02')
                    msg.push('若採遠距投保，請務必記得書面分析報告需於客戶視訊同一日完成，逾期會導致退件失效')
                    msg.push('【遠距投保】請業務同仁應清楚告知客戶進行時之操作環境、步驟與於視訊期間可能發生之問題（如網路中斷）及將採行之調整措施，並提醒客戶視訊時，應確保網路環境之安全（如勿使用公共 Wi-Fi、公用電腦或在公共場所投保等）。(依外規要求辦理) ')
                    if (this.cusInfoTypeO.insureAge > this.insHighAgeLimit) { // 檢查要保人是否為高齡(65歲以上)
                      msg.push('您進件之要保人為高齡，請確認是否已於保險公司完成高齡錄音並記下錄音編號(進入APP時需填寫)')
                    }
                    if (new Date().getHours() >= this.insAppTime.limit) { // 檢核操作流程時間是否於18點後
                      msg.push('目前已逾' + this.insAppTime.desc + '，因進件保險公司APP僅能同日12小時內完成(不得跨日)，請務必確認今日晚上可完成APP流程及客戶簽名，以避免需隔日重來。')
                    }
                    let list = []
                    let num = 1
                    msg.forEach(el => {
                      el = '(' + num + ')'  + el
                      num++
                      list.push(el)
                    })

                    this.$confirm('<div style="text-align:left">' + list.join('<br>') + '</div>', yn => {
                      if (yn) {
                        this.$store.dispatch('ins/updatePolState', ({ transCode , polState: 'O' })) // 更新保單狀態
                          this.fetchJumpApp({ transCode ,compCode: this.compCode, insAcceptNo: this.policiesInfo.insAcceptNo }).then(r => {
                            this.$postUserAccessLog({ progClassName: 'attachmentUpload_jumpApp', methodName: '轉跳APP(遠距)', stepCode: this.tabStep, transCode: this.transCode })
                            const { url } = r.data
                            window.open(url, '_blank', 'noreferrer') // 跳轉保險公司
                            this.$router.replace({ name: 'proposal' })
                          })
                      }
                    })
                  }
                })
              }
            })
          }
        }
    }),
    preStepHandler: withDebounce(function () {
      this.$postUserAccessLog({ progClassName: 'attachmentUpload_prev', methodName: '上一步', stepCode: this.tabStep })
      this.$preStepHandler()
    }),
    resetHandler () {
      this.delAllFile({transCode: this.transCode}).then(() => {
        this.fetchInsPoliciesPolf({ // 重取檔案列表
        transCode: this.transCode,
        fileGroup: ['ATTACH']
        }).then(r => {
          this.insFileList = []
          if (r.data.length > 0) {
            this.insFileList = r.data
          }
          this.$refs['filesA'].onResetfile()
          if (this.loginRole) {
            this.$refs['filesB'].onResetfile()
          }
          this.$refs['filesC'].onResetfile()
          this.changedFlag = true
          this.$postUserAccessLog({ progClassName: 'attachmentUpload_clear', methodName: '全部清除', stepCode: this.tabStep })
          this.$reset('observer')
          this.$emit('go-top')
        })
      })
    },
    onUpload (updFileObj) { // 上傳
      const { insFileList } = this
      let fileArray =  filter(insFileList, function(f) { // 取得該列別已上傳檔案數
        return f.fileType == updFileObj.fileType
      })
      let fileSize = fileArray.length ? fileArray.length : 0
      if ( 1 <= fileSize && updFileObj.fileType === 'A' ) { // 行動投保同意書上傳限制
        this.$alert('已超過上傳檔案數量限制: 1' ) // #55609 固定值數量1
      }else if (this.insFileLimit <= fileSize && updFileObj.fileType !== 'C' ) {
        this.$alert('已超過上傳檔案數量限制: ' + this.insFileLimit)
      }else if (this.insOtherFileLimit <= fileSize && updFileObj.fileType === 'C' ) { // 其他附件檔案上傳限制
        this.$alert('已超過上傳檔案數量限制: ' + this.insOtherFileLimit)
      } else if (updFileObj && updFileObj.files && updFileObj.fileType) {
        this.startLoading()
          const opt = {
          files: updFileObj.files,
          fileName: updFileObj.fileName,
          base64Str: updFileObj.base64Str,
          fileType: updFileObj.fileType,
          stepCode: this.stepCode,
          transCode: this.transCode
        }
        this.postUpdFileBase64(opt).then(r => {
          this.changedFlag = true
          this.$postUserAccessLog({ progClassName: 'attachmentUpload_upload', methodName: '上傳', stepCode: this.tabStep })
          this.fetchInsPoliciesPolf({ // 重取檔案列表
            transCode: this.transCode,
            fileGroup: ['ATTACH'],
          }).then(r => {
            this.insFileList = []
            if (r.data.length > 0) {
              this.insFileList = r.data
            }
            return r
          })
        })
      }
      setTimeout(() => {
        this.endLoading()
      }, 3000)
    },
    filePickerLog () {
      this.$postUserAccessLog({ progClassName: 'attachmentUpload_filePicker', methodName: '選擇檔案', stepCode: this.tabStep })
    },
    doValidate (setDoneFlag) {
      this.$doValidate('observer').then(isValid => {
        if (!isValid) {
          let num = this.$validateNum('observer')
          this.$emit('set-validate-num', { step: this.tabStep, num })
        } else {
          this.$emit('set-validate-num', { step: this.tabStep, num: 0 })
          if (setDoneFlag) {
            this.$setTabDone(this.tabStep, true )
          }
        }
      })
    },
    onDelete (fileCode) { // 刪除
      this.startLoading()
      if (fileCode && fileCode.length) {
        const opt = {
          fileCode: fileCode,
          stepCode: this.stepCode,
          transCode: this.transCode
        }
        this.delFile(opt).then(r => {
          this.changedFlag = true
          this.fetchInsPoliciesPolf({ // 重取檔案列表
            transCode: this.transCode,
            fileGroup: ['ATTACH']
          }).then(r => {
            this.insFileList = []
            if (r.data.length > 0) {
              this.insFileList = r.data
            }
          })
        })
      }
      setTimeout(() => {
        this.endLoading()
      }, 3000)
    },
    onChangeHasTmp (hasTmpFileObj) { // 還沒上傳的檔案檢查
      switch (hasTmpFileObj.fileType) {
        case 'A':
          this.hasTmpFileA = hasTmpFileObj.hasTmpFile
          break
        case 'B':
          this.hasTmpFileB = hasTmpFileObj.hasTmpFile
          break
        case 'C':
          this.hasTmpFileC = hasTmpFileObj.hasTmpFile
          break
      }
      this.allHasTmpFile = this.hasTmpFileA || this.hasTmpFileB || this.hasTmpFileC
    },
    errorsHandler (errors) {
      const errorsArray = this.$errorMsgHandler(errors)
      return errorsArray
    },
    consentDownloadHandler () { //同意書下載
      let transCode = this.transCode
      let insureNo = this.insureNo
      const idStr = 'downloadConsentPdf_Link'
      let url = this.$api.defaults.baseURL +
      '/ins/common/insPolicies/downloadConsentPdf?transCode='+ transCode
      // 因為對於 Safari 瀏覽器，由於它不支持 download 屬性，改為在新的分頁中打開檔案
      if (this.$isSafari) {
      // 添加 rel 屬性 阻止新開的頁面取得 window.opener 的引用，從而防止其控制來源頁面
       var newWindow =window.open(url, "_blank", 'noreferrer');
        if (newWindow) {
          newWindow.opener = null;
        }
      } else {
        let link = null
        link = document.getElementById(idStr)
        if (!link) {
          link = document.createElement('a')
          link.id = idStr
          link.style.display = 'none'
          link.target = '_blank'
          link.rel = 'noopener noreferrer' // 新增 rel 屬性 Unsafe Use Of Target blank
          document.body.appendChild(link)
        }
        link.href = url
        let fileName = '行動投保確認同意書_' + insureNo + '.pdf'
        link.setAttribute('download', fileName)
        this.startLoading()
        link.click()

        setTimeout(() => {
          this.endLoading()
        }, 1000)
      }
      this.insStepHandler({ progClassName: 'proposal_consentDownload', methodName: '同意書下載', stepCode: '', transCode: this.transCode})
    },
    insStepHandler ({
      progClassName,
      methodName,
      stepCode,
      actionMsg,
      transCode
    }) {
      this.$store.dispatch('common/postUserAccessLog', {
          transCode: transCode,
          actionMsg: actionMsg,
          progClassName: progClassName,
          methodName: methodName,
          sysType: 'F',
          stepCode: stepCode
        })
        .then(r => {})
    },
  }
}
</script>
